// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-datasource-confirm-study{line-height:1.4;text-align:center;width:260px}.ac-datasource-confirm-study__study-name{font-weight:bold}\n", ""]);
// Exports
module.exports = exports;
